export const PRODUCT_DETAILS_MODAL_OPEN = 'PRODUCT_DETAILS_MODAL_OPEN';
export const openProductDetailModal = (productId) => ({
  type: PRODUCT_DETAILS_MODAL_OPEN,
  productId,
});

export const BULK_LOAD_PRODUCT_DATA = 'BULK_LOAD_PRODUCT_DATA';
export const bulkLoadProductData = (productIds) => ({
  type: BULK_LOAD_PRODUCT_DATA,
  productIds,
});

export const FORCE_BULK_LOAD_PRODUCT_DATA = 'FORCE_BULK_LOAD_PRODUCT_DATA';
export const forceBulkLoadProductData = (productIds) => ({
  type: FORCE_BULK_LOAD_PRODUCT_DATA,
  productIds,
});

export const GET_PRODUCT_DETAILS_SUCCESS = 'GET_PRODUCT_DETAILS_SUCCESS';
export const getProductDetailsSuccess = (productData) => ({
  type: GET_PRODUCT_DETAILS_SUCCESS,
  payload: {
    productData,
  },
});

export const GET_PRODUCT_PROFILES_SUCCESS = 'GET_PRODUCT_PROFILES_SUCCESS';
export const getProductProfilesSuccess = (productProfiles) => ({
  type: GET_PRODUCT_PROFILES_SUCCESS,
  payload: {
    productProfiles,
  },
});

export const GET_PRODUCT_CATEGORIES_SUCCESS = 'GET_PRODUCT_CATEGORIES_SUCCESS';
export const getProductCategoriesSuccess = (productCategories) => ({
  type: GET_PRODUCT_CATEGORIES_SUCCESS,
  payload: {
    productCategories,
  },
});

export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
const updateProductSuccess = () => ({
  type: UPDATE_PRODUCT_SUCCESS,
});

export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';
const updateProductFailure = (error) => ({
  type: UPDATE_PRODUCT_FAILURE,
  payload: new Error(error),
  error: true,
});

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const updateProduct = (product, updateOptions, modalId) => ({
  type: UPDATE_PRODUCT,
  payload: { product, updateOptions, modalId },
  meta: {
    onSuccess: updateProductSuccess,
    onError: updateProductFailure,
  },
});

export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const createProduct = (product, updateOptions, modalId) => ({
  type: CREATE_PRODUCT,
  payload: { product, updateOptions, modalId },
  meta: {
    onSuccess: updateProductSuccess,
    onError: updateProductFailure,
  },
});

export const APPLY_PRODUCT_UPDATE_TO_OPEN_FULFILLMENTPLANS_SUCCESS = 'APPLY_PRODUCT_UPDATE_TO_OPEN_FULFILLMENTPLANS_SUCCESS';
export const applyProductUpdateToOpenFulfillmentPlanSuccess = (dataLoadSuccessNotificationConfig, dataLoadFailureNotificationConfig) => ({
  type: APPLY_PRODUCT_UPDATE_TO_OPEN_FULFILLMENTPLANS_SUCCESS,
  payload: {
    dataLoadSuccessNotificationConfig,
    dataLoadFailureNotificationConfig,
  },
});

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const getProducts = () => ({
  type: GET_PRODUCTS,
});

export const ADD_WAREHOUSE_TO_PRODUCTS = 'ADD_WAREHOUSE_TO_PRODUCTS';
export const addWarehouseToProducts = (productIds, warehouseId) => ({
  type: ADD_WAREHOUSE_TO_PRODUCTS,
  productIds,
  warehouseId,
});

export const REMOVE_WAREHOUSE_FROM_PRODUCTS = 'REMOVE_WAREHOUSE_FROM_PRODUCTS';
export const removeWarehouseFromProducts = (productIds, warehouseId) => ({
  type: REMOVE_WAREHOUSE_FROM_PRODUCTS,
  productIds,
  warehouseId,
});

export const UPDATE_PRODUCT_WAREHOUSE_ASSOCIATIONS = 'UPDATE_PRODUCT_WAREHOUSE_ASSOCIATIONS';
export const updateProductWarehouseAssociations = (productIds, warehouseIdsToAdd, warehouseIdsToDelete) => ({
  type: UPDATE_PRODUCT_WAREHOUSE_ASSOCIATIONS,
  productIds,
  warehouseIdsToAdd,
  warehouseIdsToDelete,
});

export const ADD_TAGS_TO_PRODUCTS = 'ADD_TAGS_TO_PRODUCTS';
export const addTagsToProducts = (productIds, tagId) => ({
  type: ADD_TAGS_TO_PRODUCTS,
  productIds,
  tagId,
});

export const REMOVE_TAGS_FROM_PRODUCTS = 'REMOVE_TAGS_FROM_PRODUCTS';
export const removeTagsFromProducts = (productIds, tagId) => ({
  type: REMOVE_TAGS_FROM_PRODUCTS,
  productIds,
  tagId,
});

export const SET_SHOULD_USE_AGGREGATE_INVENTORY = 'SET_SHOULD_USE_AGGREGATE_INVENTORY';
export const setUseAggregateInventory = (shouldUseAggregateInventory) => ({
  type: SET_SHOULD_USE_AGGREGATE_INVENTORY,
  shouldUseAggregateInventory,
});

export const GET_PRODUCT_IMPORT_LOG = 'GET_PRODUCT_IMPORT_LOG';
export const getProductImportLogFromJobGuid = (importJobGuid) => ({
  type: GET_PRODUCT_IMPORT_LOG,
  importJobGuid,
});

export const GET_PRODUCT_IMPORT_LOG_PARTIAL_SUCCESS = 'GET_PRODUCT_IMPORT_LOG_PARTIAL_SUCCESS';
export const getProductImportLogSuccess = (importErrors) => ({
  type: GET_PRODUCT_IMPORT_LOG_PARTIAL_SUCCESS,
  importErrors,
});

export const GET_PRODUCT_IMPORT_SUCCESS = 'GET_PRODUCT_IMPORT_SUCCESS';
export const getProductImportSuccess = () => ({
  type: GET_PRODUCT_IMPORT_SUCCESS,
});

export const CLEAR_PRODUCT_IMPORT_LOG = 'CLEAR_PRODUCT_IMPORT_LOG';
export const clearProductImportLog = () => ({
  type: CLEAR_PRODUCT_IMPORT_LOG,
});

export const GET_PRODUCT_EXPORT_SUCCESS = 'GET_PRODUCT_EXPORT_SUCCESS';
export const getProductExportSuccess = () => ({
  type: GET_PRODUCT_EXPORT_SUCCESS,
});
